const aed = [
  {
    id: 1,
    label: 'AED設施(圖書館內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958034,121.240504',
    position: { lat: 24.958034, lng: 121.240504 },
    entry: { lat: 24.958034, lng: 121.240504 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 2,
    label: 'AED(維澈樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957169,121.240654',
    position: { lat: 24.957169, lng: 121.240654 },
    entry: { lat: 24.957169, lng: 121.240654 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 3,
    label: 'AED(真知教學大樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956477,121.241967',
    position: { lat: 24.956477, lng: 121.241967 },
    entry: { lat: 24.956477, lng: 121.241967 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 4,
    label: 'AED(電學大樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955815,121.242558',
    position: { lat: 24.955815, lng: 121.242558 },
    entry: { lat: 24.955815, lng: 121.242558 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 5,
    label: 'AED(良善樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955638,121.242343',
    position: { lat: 24.955638, lng: 121.242343 },
    entry: { lat: 24.955638, lng: 121.242343 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 6,
    label: 'AED(望樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955712,121.245070',
    position: { lat: 24.955712, lng: 121.245070 },
    entry: { lat: 24.955712, lng: 121.245070 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 7,
    label: 'AED(工學館內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957121,121.244134',
    position: { lat: 24.957121, lng: 121.244134 },
    entry: { lat: 24.957121, lng: 121.244134 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 8,
    label: 'AED(管理大樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957311,121.243608',
    position: { lat: 24.957311, lng: 121.243608 },
    entry: { lat: 24.957311, lng: 121.243608 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 9,
    label: 'AED(科學館內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957645,121.241874',
    position: { lat: 24.957645, lng: 121.241874 },
    entry: { lat: 24.957645, lng: 121.241874 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 10,
    label: 'AED(全人教育村大樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958899,121.242219',
    position: { lat: 24.958899, lng: 121.242219 },
    entry: { lat: 24.958899, lng: 121.242219 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 11,
    label: 'AED(例行大樓內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959534,121.241111',
    position: { lat: 24.959534, lng: 121.241111 },
    entry: { lat: 24.959534, lng: 121.241111 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 12,
    label: 'AED(體育館內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960183,121.242261',
    position: { lat: 24.960183, lng: 121.242261 },
    entry: { lat: 24.960183, lng: 121.242261 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 13,
    label: 'AED(信實宿舍內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959566,121.245839',
    position: { lat: 24.959566, lng: 121.245839 },
    entry: { lat: 24.959566, lng: 121.245839 },
    path: './number/cycu-number-AED.svg',
  },
  {
    id: 14,
    label: 'AED(熱誠宿舍內)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960579,121.245783',
    position: { lat: 24.960579, lng: 121.245783 },
    entry: { lat: 24.960579, lng: 121.245783 },
    path: './number/cycu-number-AED.svg',
  },
];

export default aed;
